import { restClient } from '../client';

export const betterhelpSsoInit = () =>
  restClient.request<
    | { data: { binding: 'redirect'; redirect_url: string } }
    | { data: { binding: 'post'; post_url: string; saml_request: string; relay_state?: string } }
  >('/api/v1/betterhelp/sso/init', {
    method: 'GET'
  });

export const betterhelpSsoExchange = (code: string) =>
  restClient.request<{ data: { access_token: string; refresh_token: string } }>(
    '/api/v1/betterhelp/sso/exchange',
    { method: 'POST', data: { code } }
  );

export const betterhelpSsoLinkConfirm = (intent: string) =>
  restClient.request<{ data: { code: string } }>('/api/v1/betterhelp/sso/link/confirm', {
    method: 'POST',
    data: { intent },
  });
